import { CASES } from "./constants";
import { safeGetJSON } from "tap/utils/safeLocalStorage";
import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  getInitialPaginationRange,
  getStoredItemsPerPage,
  PAGINATION_STORAGE_KEYS,
  persistItemsPerPageFromPayload,
  withPreservedPagination,
} from "tap/utils/paginationPreferences.js";

const paginationKeys = {
  itemsPerPage: PAGINATION_STORAGE_KEYS.pmxDeliveries,
};
const initialItemsPerPage = getStoredItemsPerPage(paginationKeys.itemsPerPage);
const initialPaginationRange = getInitialPaginationRange(initialItemsPerPage);

const getInitialPMXDeliveriesSort = () => {
  return safeGetJSON("pmxDeliveriesSort", ["id", "DESC"]);
};

const initialState = {
  deliveries: [],
  refreshPMXDeliveries: false,
  filterForm: {
    skuId: "",
    action: "",
    status: "",
  },
  actionOptions: [
    { value: "CREATE", label: "Create" },
    { value: "UPDATE", label: "Update" },
    { value: "DELETE", label: "Delete" },
  ],
  statusOptions: [
    { value: "READY", label: "Ready" },
    { value: "COMPLETE", label: "Complete" },
    { value: "ERROR", label: "Error" },
    { value: "SKIPPED", label: "Skipped" },
    { value: "HOLD", label: "Hold" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "REPROCESS", label: "Reprocess" },
  ],
  totalPages: 0,
  totalItems: 0,
  currentPage: 0,
  filterParam: "",
  pmxDeliveriesRange: initialPaginationRange,
  pmxDeliveriesSort: getInitialPMXDeliveriesSort(),
  defaultFilterRange: initialPaginationRange,
  itemsPerPage: initialItemsPerPage,
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
};

export function pmxDeliveries(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CASES.UPDATE_PMX_DELIVERIES: {
      if (payload.pmxDeliveriesSort) {
        localStorage.setItem(
          "pmxDeliveriesSort",
          JSON.stringify(payload.pmxDeliveriesSort),
        );
      }
      persistItemsPerPageFromPayload(payload, paginationKeys);
      return { ...state, ...payload };
    }
    case CASES.UPDATE_PMX_DELIVERIES_SEARCH_FORM: {
      const { data, key } = payload;
      return { ...state, [key]: { ...state[key], ...data } };
    }
    case CASES.CLEAR_PMX_DELIVERIES: {
      return withPreservedPagination(
        state,
        {
          ...initialState,
          pmxDeliveriesSort: state.pmxDeliveriesSort,
        },
        ["pmxDeliveriesRange"],
      );
    }
    default:
      return state;
  }
}
